export default __webpack_public_path__ + "static/media/istockphoto-926167508-170667a.9b0001a4.jpg";